export default __webpack_public_path__ + "static/battle-map-14163faf5b8b397e8cfa91e85bfb9ac6.png";